import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { DocumentOrderField } from "documents/_api/queries/document-query";
import { z } from "zod";

export type DocumentOrderParameters = z.infer<typeof DocumentOrderSchema.DocumentOrderZ>;

export default class DocumentOrderSchema {
  public static readonly DocumentOrderZ = z.object({
    orderBy: z.enum(DocumentOrderField).optional(),
    orderDir: z.enum(OrderDirection).optional(),
  });

  public static create(values: DocumentOrderParameters): DocumentOrderParameters {
    return parseOrThrow(DocumentOrderSchema.DocumentOrderZ, values, {
      logError: true,
      schemaName: "DocumentOrderSchema",
      operation: "create",
      payloadSample: values,
    });
  }
}
